import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Head from 'next/head';

const PageTitle = ({ name }) => {
    const intl = useIntl();

    return (
        <Head>
            {name && (<title>{intl.formatMessage({ id: `App.restaurant` })} | {name}</title>)}
            {name && (
                <meta
                  name="description"
                // eslint-disable-next-line max-len
                  content={`Zamawiaj prosto do stolika w ${name}. Zawsze aktualne menu, przeglądaj, zamawiaj i śledź swoje zamówienie z apetit.io.`}
                  key="description"
                />
            )}
            {!name && (<title>apetit.io</title>)}
            <link rel="icon" href="/favicon.ico" />
        </Head>
    );
};

PageTitle.propTypes = {
    name: PropTypes.string
};

export default PageTitle;
